import { IButtonStyles, IStackStyles, IStyle, mergeStyles } from '@fluentui/react';

import { FontSizes, IH2OTheme, Sizes } from '@shared-legacy/ui-kit';

export const defaultPagePadding = `${Sizes.contentPaddingTop}px 30px 100px`;

export const DefaultPageStyles: IStyle = {
  padding: defaultPagePadding,
  margin: '0 auto',
  maxWidth: '2000px',
  width: '100%',
  position: 'relative',
};

// *********** Fluent components styles **********
export const stackStylesAppContainer: Partial<IStackStyles> = {
  root: {
    '*': {
      boxSizing: 'border-box',
    },
    minHeight: '100vh',
    '.checkbox__centered': {
      display: 'flex',
      alignItems: 'center',
    },
  },
};
export const stackStylesPage: Partial<IStackStyles> = {
  root: {
    ...DefaultPageStyles,
  },
};

export const stackStylesNoLeftNav: Partial<IStackStyles> = {
  root: {
    ...DefaultPageStyles,
  },
};

export const stackStylesAppStorePage: Partial<IStackStyles> = {
  root: {
    padding: defaultPagePadding,
  },
};

export const stackStylesInnerPivotPage: Partial<IStackStyles> = {
  root: {
    ...DefaultPageStyles,
    padding: 0,
  },
};

export const stackStylesLog = (theme: IH2OTheme): Partial<IStackStyles> => ({
  root: {
    ...DefaultPageStyles,
    padding: `${Sizes.contentPaddingTop}px 0 0 0`,
    flex: 1,
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    '.log-container': {
      backgroundColor: theme.palette?.gray900,
      flex: 1,
      overflow: 'auto',
    },
    minWidth: '100%',
  },
});

// ***** ui-kit components need the project styles only.
// The default and common themes are in the components so don't need to copy them ****

export const buttonStylesRow: Partial<IButtonStyles> = {
  root: {
    marginLeft: '8px',
  },
};

export const buttonStylesGray = (theme: IH2OTheme): Partial<IButtonStyles> => ({
  root: {
    borderColor: theme.palette?.gray600,
    color: theme.palette?.gray600,
  },
});

export const classNameIconInfo = (theme: IH2OTheme) => {
  return mergeStyles({
    paddingInline: 7,
    fontSize: FontSizes.medium,
    color: theme.semanticColors?.textQuinary,
  });
};
